import React from "react";
import "./NoSummary.css"

const LoadingScreen = ({message}) => {
  return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="illustration">
            <img
              src="/Loading.png"
              alt="Processing illustration"
            />
          </div>
          <div className="text-content">
            <h1>Generating Your {message}...</h1>
            <p>Please wait while we process and compile your session details.</p>
          </div>
        </div>
      </div>
  );
};

export default LoadingScreen;
